import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';

import materialTheme from '../../reactMaterialTheme';
import './MediaUrlField.css';

class MediaUrlField extends Component {
  constructor(props) {
    super(props);
    this.fetchOgCreativeAttributes = this.fetchOgCreativeAttributes.bind(this);
  }

  fetchOgCreativeAttributes() {
    this.props.OpenGraphDataService.updateCreativeWithOgData(
      this.props.creative
    ).then(ogResponse => this.props.onOgResponse(ogResponse));
  }

  render() {
    return (
      <div className="row mt2 mb2">
        <div className="col-xs-12">
          <div className="col-xs-7 no-gutters">
            <MuiThemeProvider theme={materialTheme}>
              <TextField
                label="Clickout URL"
                className="media-url-field"
                value={this.props.mediaUrl}
                onChange={this.props.onChange}
                name="mediaUrl"
                inputProps={{ 'data-testid': 'media-url-input' }}
                required
              />
            </MuiThemeProvider>
          </div>
          <div className="col-xs-2 pt2 pl0 ml3">
            <button
              aria-label="Pull Content"
              className="btn btn-secondary"
              onClick={this.fetchOgCreativeAttributes}
              type="button"
            >
              Pull Content
            </button>
          </div>
        </div>
      </div>
    );
  }
}

MediaUrlField.propTypes = {
  creative: PropTypes.object.isRequired,
  mediaUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  OpenGraphDataService: PropTypes.object.isRequired,
  onOgResponse: PropTypes.func.isRequired
};

MediaUrlField.defaultProps = {
  mediaUrl: ''
};

export default MediaUrlField;
